<template>
  <nav
    class="flex flex-col md:flex-row items-center justify-center md:justify-between flex-wrap py-6 md:px-4 xl:px-12 bg-white dark:bg-bs-dark-bg-over top-bar"
  >
   
    <h2 class="font-bold text-3xl text-bs-dark-bg dark:text-white">{{title}}</h2>
    <div class="w-full md:w-auto flex flex-row justify-center md:flex-row items-center">
      
      <a target="_blank" href="https://x.com/Betslip_Tips" class="p-2 rounded-full bg-gray-200 dark:bg-bs-dark-bg bg-opacity-50 mr-2"><img src="/img/social/x.svg" alt="Follow Betslip on X" class="w-8 h-8" :style="theme === 'dark' ? 'filter: invert(1)' : ''" /></a>
      <a target="_blank" href="https://t.me/betsliptips_free" class="mx-2 p-2 rounded-full bg-gray-200 dark:bg-bs-dark-bg bg-opacity-50"><img src="/img/social/telegram.svg" alt="Betslip on Telegram" class="w-8 h-8" /></a>
      <Avatar class="hidden md:block"/>
    </div>
  </nav>
</template>

<script>
// import Menu from "@/components/molecules/Menu.vue";
import Avatar from "@/components/atoms/Avatar.vue";
import { mapState } from 'vuex';
export default {
  props: ['title'],
  name: "NavBar",
  components: {
    // Menu,
    Avatar
  },
  data: function() {
    return {
      menuItems: [
        {
          text: "Home",
        },
      ],
    };
  },
  computed: {
		...mapState(['theme'])
	},
  methods: {
  },
};
</script>

<style>
.topup-btn {
  @apply bg-yellow-500 hover:bg-yellow-600 px-5 py-3 rounded-full pr-12 -mr-8 font-medium;
}
</style>
